import { Box, Stack } from "@mui/material";
import React from "react";
interface RowInfoProps {
  start?: React.ReactNode;
  middle?: React.ReactNode;
  end?: React.ReactNode;
  under?: React.ReactNode;
}

export const RowInfo = ({ start, middle, end, under }: RowInfoProps) => {
  return (
    <Stack>
      <Stack direction="row" sx={{
        justifyContent: "space-between"
      }}>
        <Stack direction="row" sx={{
          gap: "8px"
        }}>
          {start}
          {middle}
        </Stack>
        {end}
      </Stack>
      <Box sx={{
        paddingLeft: "31px"
      }}>{under}</Box>
    </Stack>
  );
};
